// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Addadvertisements_container__Jyijt {
  background-color: #1e1e1e;
  color: #f8f8f8;
  padding: 30px;
  border-radius: 10px;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 5px 15px rgba(255, 51, 51, 0.2);
}

.Addadvertisements_heading__e8N1N {
  text-align: center;
  margin-top: 100px;
  margin-bottom: 30px;
  color: #ff3333;
  font-size: 28px;
  border-bottom: 2px solid #ff3333;
  padding-bottom: 10px;
}

.Addadvertisements_form__aeYQh {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Addadvertisements_formGroup__nhMXP {
  margin-bottom: 10px;
  width: 100%;
}

.Addadvertisements_formRow__EMgJc {
  display: flex;
  gap: 60px;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .Addadvertisements_formRow__EMgJc {
    flex-direction: column;
    gap: 10px;
  }
}

.Addadvertisements_label__jgAng {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #ff3333;
}

.Addadvertisements_input__xVz-T, .Addadvertisements_select__or4eZ, .Addadvertisements_textarea__WAxvk {
  width: 100%;
  padding: 12px;
  border: 1px solid #444;
  border-radius: 6px;
  background-color: #2a2a2a;
  color: #f8f8f8;
  font-size: 16px;
  transition: all 0.3s ease;
}

.Addadvertisements_input__xVz-T:focus, .Addadvertisements_select__or4eZ:focus, .Addadvertisements_textarea__WAxvk:focus {
  border-color: #ff3333;
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 51, 51, 0.2);
}

.Addadvertisements_textarea__WAxvk {
  resize: vertical;
  min-height: 100px;
}
.Addadvertisements_checkboxGroup__igz3x {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
}
.Addadvertisements_checkboxLabel__6LUFz {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.Addadvertisements_checkbox__d1Ys\\+ {
  margin-right: 10px;
  width: 18px;
  height: 18px;
  accent-color: #ff3333;
}

.Addadvertisements_buttonContainer__zSbla {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
}

.Addadvertisements_submitButton__ej5QB, .Addadvertisements_cancelButton__o-HE3, .Addadvertisements_previewButton__sBdxL {
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.Addadvertisements_submitButton__ej5QB {
  background-color: #ff3333;
  color: #fff;
  font-weight: 500;
}

.Addadvertisements_submitButton__ej5QB:hover {
  background-color: #cc0000;
  transform: translateY(-2px);
}

.Addadvertisements_cancelButton__o-HE3 {
  background-color: transparent;
  color: #ff3333;
  border: 1px solid #ff3333;
  font-weight: 500;
}

.Addadvertisements_cancelButton__o-HE3:hover {
  background-color: rgba(255, 51, 51, 0.1);
  transform: translateY(-2px);
}
/* Image Upload Section Styles */
.Addadvertisements_imagePreviewContainer__p-5M0 {
  margin-top: 10px;
  padding: 10px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Addadvertisements_imagePreview__4Hxbo {
  max-width: 400px;
  height: 400px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.Addadvertisements_removeImageButton__MqzPg {
  background-color: #ff3333;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.Addadvertisements_removeImageButton__MqzPg:hover {
  background-color: #e62e2e;
}
@media (max-width: 360px) {
  .Addadvertisements_submitButton__ej5QB, .Addadvertisements_cancelButton__o-HE3, .Addadvertisements_previewButton__sBdxL {
    padding: 12px 12px;
    border-radius: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/Banner-Ads/Addadvertisements.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  background-color: #1e1e1e;\n  color: #f8f8f8;\n  padding: 30px;\n  border-radius: 10px;\n  max-width: 800px;\n  margin: 0 auto;\n  box-shadow: 0 5px 15px rgba(255, 51, 51, 0.2);\n}\n\n.heading {\n  text-align: center;\n  margin-top: 100px;\n  margin-bottom: 30px;\n  color: #ff3333;\n  font-size: 28px;\n  border-bottom: 2px solid #ff3333;\n  padding-bottom: 10px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.formRow {\n  display: flex;\n  gap: 60px;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 768px) {\n  .formRow {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n.label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #ff3333;\n}\n\n.input, .select, .textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #444;\n  border-radius: 6px;\n  background-color: #2a2a2a;\n  color: #f8f8f8;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.input:focus, .select:focus, .textarea:focus {\n  border-color: #ff3333;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(255, 51, 51, 0.2);\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n.checkboxGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.checkbox {\n  margin-right: 10px;\n  width: 18px;\n  height: 18px;\n  accent-color: #ff3333;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.submitButton, .cancelButton, .previewButton {\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.submitButton {\n  background-color: #ff3333;\n  color: #fff;\n  font-weight: 500;\n}\n\n.submitButton:hover {\n  background-color: #cc0000;\n  transform: translateY(-2px);\n}\n\n.cancelButton {\n  background-color: transparent;\n  color: #ff3333;\n  border: 1px solid #ff3333;\n  font-weight: 500;\n}\n\n.cancelButton:hover {\n  background-color: rgba(255, 51, 51, 0.1);\n  transform: translateY(-2px);\n}\n/* Image Upload Section Styles */\n.imagePreviewContainer {\n  margin-top: 10px;\n  padding: 10px;\n  border: 2px dashed #ccc;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.imagePreview {\n  max-width: 400px;\n  height: 400px;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n\n.removeImageButton {\n  background-color: #ff3333;\n  color: #fff;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.removeImageButton:hover {\n  background-color: #e62e2e;\n}\n@media (max-width: 360px) {\n  .submitButton, .cancelButton, .previewButton {\n    padding: 12px 12px;\n    border-radius: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Addadvertisements_container__Jyijt`,
	"heading": `Addadvertisements_heading__e8N1N`,
	"form": `Addadvertisements_form__aeYQh`,
	"formGroup": `Addadvertisements_formGroup__nhMXP`,
	"formRow": `Addadvertisements_formRow__EMgJc`,
	"label": `Addadvertisements_label__jgAng`,
	"input": `Addadvertisements_input__xVz-T`,
	"select": `Addadvertisements_select__or4eZ`,
	"textarea": `Addadvertisements_textarea__WAxvk`,
	"checkboxGroup": `Addadvertisements_checkboxGroup__igz3x`,
	"checkboxLabel": `Addadvertisements_checkboxLabel__6LUFz`,
	"checkbox": `Addadvertisements_checkbox__d1Ys+`,
	"buttonContainer": `Addadvertisements_buttonContainer__zSbla`,
	"submitButton": `Addadvertisements_submitButton__ej5QB`,
	"cancelButton": `Addadvertisements_cancelButton__o-HE3`,
	"previewButton": `Addadvertisements_previewButton__sBdxL`,
	"imagePreviewContainer": `Addadvertisements_imagePreviewContainer__p-5M0`,
	"imagePreview": `Addadvertisements_imagePreview__4Hxbo`,
	"removeImageButton": `Addadvertisements_removeImageButton__MqzPg`
};
export default ___CSS_LOADER_EXPORT___;
